<template>
  <b-row cols="1" cols-sm="1" cols-md="1" cols-lg="1" cols-xl="1" class="homepage">
    <b-col>

      <header>
        <h1>Deploy anywhere. Instantly.</h1>
        <h3>Your app runs exactly where you want it — with sovereign data, low latency, and full compliance.</h3>
        <br>
        <br>
        <router-link :to="{ name: user.email ? 'Deployments' : 'SignUp' }">
          <button class="cta">Connect your GitHub – Start Free</button>
        </router-link>
        <br>
        <br>
        <button @click="openCalendly" class="cta">Book a demo</button>

        <div class="margin-100">
        </div>

        <blockquote class="quote">
          <p>Unlike Heroku, you’re not stuck with “Europe” or “North America.”<br>
          With Deploy10, you deploy by country. No DevOps required.</p>
        </blockquote>

        <div class="margin-150">
        </div>

        <div class="supported">
          <h2>Supported Runtimes</h2>
          <div class="runtime-logos">
            <div class="runtime">
              <img src="../../public/homepage/node.png" alt="Node.js"><span>Node.js</span>
            </div>
            <div class="runtime">
              <img src="../../public/homepage/ruby.png" alt="Ruby"><span>Ruby</span>
            </div>
            <div class="runtime">
              <img src="../../public/homepage/php.png" alt="PHP"><span>PHP</span>
            </div>
            <div class="runtime">
              <img src="../../public/homepage/python.png" alt="Python"><span>Python</span>
            </div>
          </div>

          <h3>and static frontends</h3>
          <div class="runtime-logos">
            <div class="runtime">
              <img src="../../public/homepage/js.png" alt="JS"><span>JavaScript</span>
            </div>
            <div class="runtime">
              <img src="../../public/homepage/vue.png" alt="Vue.js"><span>Vue.js</span>
            </div>
            <div class="runtime">
              <img src="../../public/homepage/react.png" alt="React.js"><span>React.js</span>
            </div>
            <div class="runtime">
              <img src="../../public/homepage/angular.png" alt="Angular"><span>Angular</span>
            </div>
          </div>
        </div>
      </header>

      <div class="margin-top-25">
      </div>

      <section class="section">
        <h2>Why choose Deploy10?</h2>
        <div class="features">
          <div class="feature">
            <h3>🇪🇺 Data Sovereignty</h3>
            <p>Deploy in France, Germany, Canada, Switzerland, and more. Your data stays in your chosen countries – no cross-border transfers.</p>
          </div>
          <div class="feature">
            <h3>⚡ Instant Deploys</h3>
            <p>Connect your GitHub, and go live in seconds. We build, deploy, and scale for you, without any config or Dockerfile needed.</p>
          </div>
          <div class="feature">
            <h3>🛡️ High Availability</h3>
            <p>If a server fails, another takes over. Always-on infrastructure powered by modern container orchestration (we keep it invisible).</p>
          </div>
          <div class="feature">
            <h3>🌍 Low Latency</h3>
            <p>Our load balancer routes traffic to the nearest server in your chosen countries. Fast apps, happy users.
            </p>
          </div>
          <div class="feature">
            <h3>🔒 Automatic SSL</h3>
            <p>We generate, manage, and renew your SSL certificates for you — completely hands-free and secure by default.</p>
          </div>
          <div class="feature">
            <h3>🚀 One-click Scaling </h3>
            <p>Need more power? Scale your app instantly with a single click — no downtime, no manual config, no stress.</p>
          </div>
          <div class="feature full-width">
            <h3>🙋‍♂️ Human Support</h3>
            <p>We’re here when you need us. Get fast, friendly support from real humans who understand your stack and your needs.</p>
          </div>
        </div>
      </section>

      <section class="section">
        <h2>Deploy10 vs Heroku</h2>
        <table class="comparison">
          <tr>
            <th>Feature</th>
            <th>Heroku</th>
            <th>Deploy10</th>
          </tr>
          <tr>
            <td>Country-level regions</td>
            <td>❌</td>
            <td>✅</td>
          </tr>
          <tr>
            <td>Load balancing to the nearest server</td>
            <td>❌</td>
            <td>✅</td>
          </tr>
          <tr>
            <td>One-click GitHub deploy</td>
            <td>✅</td>
            <td>✅</td>
          </tr>
          <tr>
            <td>Data sovereignty</td>
            <td>❌</td>
            <td>✅</td>
          </tr>
          <tr>
            <td>Human support through chat</td>
            <td>❌</td>
            <td>✅</td>
          </tr>
        </table>
      </section>

      <section class="section" style="text-align: center">
        <h2>Ready to deploy in seconds?</h2>
        <p>7 days free trial. No engagement. Get your app running today.</p>
        <router-link :to="{ name: user.email ? 'Deployments' : 'SignUp' }">
          <button class="cta">Get started now</button>
        </router-link>
      </section>

    </b-col>
  </b-row>
</template>

<script>

  export default {
    name: 'Home',
    components: {  },
    props: {

    },
    data() {
      return {

      }
    },
    created() {

    },
    computed: {
      user() {
        return this.$store.state.loggedUser;
      },
    },
    methods: {
      openCalendly() {
        window.open('https://calendly.com/marc-vanderstigel/discover-deploy10', '_blank');
      }
    }
  }
</script>

<style scoped>

</style>
